import type { IconButtonProps } from '@mui/material';
import { CloseIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import IconButton from './IconButton';

const CloseIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <IconButton ref={ref} {...props}>
        <CloseIcon />
      </IconButton>
    );
  },
);

CloseIconButton.displayName = 'CloseIconButton';
export default CloseIconButton;
